module.exports = __webpack_public_path__ + "static/img/user3.45f5ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user3.jpg
// module id = FdIc
// module chunks = 23